module.exports = __webpack_public_path__ + "static/media/main@3x.b6fb4603.png";